/**
 * Monthly EMI Calculator
 * Optimized version using binary search and a single array of objects
 */
window.MonthlyEmiCalculator = (() => {
    // Full array of price and corresponding monthly EMI
const data = [
  { price: 20, emi: 19 },
  { price: 100, emi: 29 },
  { price: 200, emi: 39 },
  { price: 300, emi: 49 },
  { price: 400, emi: 69 },
  { price: 500, emi: 59 },
  { price: 600, emi: 69 },
  { price: 700, emi: 79 },
  { price: 800, emi: 79 },
  { price: 900, emi: 79 },
  { price: 1000, emi: 79 },
  { price: 1100, emi: 79 },
  { price: 1200, emi: 89 },
  { price: 1300, emi: 99 },
  { price: 1400, emi: 99 },
  { price: 1500, emi: 109 },
  { price: 1600, emi: 109 },
  { price: 1700, emi: 119 },
  { price: 1800, emi: 119 },
  { price: 1900, emi: 129 },
  { price: 2000, emi: 129 },
  { price: 2100, emi: 139 },
  { price: 2200, emi: 149 },
  { price: 2300, emi: 149 },
  { price: 2400, emi: 149 },
  { price: 2500, emi: 159 },
  { price: 2600, emi: 159 },
  { price: 2700, emi: 169 },
  { price: 2800, emi: 169 },
  { price: 2900, emi: 179 },
  { price: 3000, emi: 189 },
  { price: 3100, emi: 189 },
  { price: 3200, emi: 189 },
  { price: 3300, emi: 189 },
  { price: 3400, emi: 199 },
  { price: 3500, emi: 199 },
  { price: 3600, emi: 199 },
  { price: 3700, emi: 199 },
  { price: 3800, emi: 199 },
  { price: 3900, emi: 209 },
  { price: 4000, emi: 209 },
  { price: 4100, emi: 219 },
  { price: 4200, emi: 219 },
  { price: 4300, emi: 229 },
  { price: 4400, emi: 239 },
  { price: 4500, emi: 239 },
  { price: 4600, emi: 249 },
  { price: 4700, emi: 249 },
  { price: 4800, emi: 259 }
];

    /**
     * Calculate the monthly EMI(Equated Monthly Installment) for a given price using binary search.
     * @param {number} price - The product price
     * @returns {number} The monthly EMI, or 0 if out of range
     */
    function calculateMonthlyEmi(price) {
        price = parseFloat(price);
        if (price < 50 || price > 4800) return 0;

        let left = 0;
        let right = data.length - 1;
        let result = 0;

        // Binary search loop
        // We search for the price in the data array.
        // If an exact match is found, we return its EMI immediately.
        // Otherwise, we are looking for the EMI corresponding to the largest price that is smaller than the target price
        while (left <= right) {
            const mid = Math.floor((left + right) / 2);

            if (data[mid].price === price) {
                return data[mid].emi;
            } else if (data[mid].price < price) {
                result = data[mid].emi; // last smaller value
                left = mid + 1;
            } else {
                right = mid - 1;
            }
        }

        return result;
    }

    return { calculateMonthlyEmi };
})();

// Make it globally accessible
window.calculateMonthlyEmi = window.MonthlyEmiCalculator.calculateMonthlyEmi;
